// extracted by css-extract-rspack-plugin
export default {"Header":"Panel-module__Header__xEN9c","HeaderContent":"Panel-module__HeaderContent__kGBUi","Heading":"Panel-module__Heading__LLNzs"};